(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dream-storefront"] && !Shopify.designMode) return;
  try {
    
function initDream(root) {
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const heroVideo = root.querySelector('.dream-hero-video');
  const toggle = root.querySelector('.dream-video-toggle');
  if (heroVideo && toggle) {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    heroVideo.muted = true;
    toggle.hidden = false;
    function updateVideoButton() {
      toggle.textContent = heroVideo.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      toggle.setAttribute('aria-pressed', String(!heroVideo.paused));
    }
    function syncMotionPreference() {
      if (preference.matches) {
        heroVideo.autoplay = false;
        heroVideo.pause();
      } else {
        heroVideo.autoplay = true;
        heroVideo.play().catch(updateVideoButton);
      }
      updateVideoButton();
    }
    toggle.addEventListener('click', () => {
      if (heroVideo.paused) heroVideo.play().catch(updateVideoButton);
      else heroVideo.pause();
    });
    heroVideo.addEventListener('play', updateVideoButton);
    heroVideo.addEventListener('pause', updateVideoButton);
    heroVideo.addEventListener('error', () => { toggle.hidden = true; });
    preference.addEventListener('change', syncMotionPreference);
    syncMotionPreference();
  }
  root.querySelectorAll('[data-dream-image]').forEach(button => button.addEventListener('click', () => {
    const image = root.querySelector('.dream-main-image img');
    if (!image) return;
    image.src = button.dataset.dreamImage;
    image.removeAttribute('srcset');
    root.querySelectorAll('[data-dream-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
  const select = root.querySelector('[data-dream-variant]');
  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    root.querySelector('[data-dream-price]').textContent = option.dataset.price;
    root.querySelector('[data-dream-sticky-price]').textContent = option.dataset.price;
    root.querySelector('.dream-add').disabled = option.dataset.available !== 'true';
  });
}
document.querySelectorAll('[data-dream-section]').forEach(initDream);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-dream-section]').forEach(initDream));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
